/**
 * "Pre-dawn console" design tokens — built for half-asleep eyes at 6 AM.
 * Night ground, dawn-gradient signature, time as the typographic hero.
 * Ported verbatim from the v2 mockups so the live app matches the design.
 */
export const T = {
  night: "#131022",
  panel: "#1E1933",
  edge: "#2D2547",
  dawn: "#FF6B45",
  gold: "#FFB454",
  mint: "#82DCA4",
  mist: "#9A92BC",
  paper: "#F4F0E6",
  dim: "#6B6390",
} as const;

/** Travel seam — diagonal stripes. */
export const seamBg = `repeating-linear-gradient(135deg, ${T.edge} 0 4px, transparent 4px 9px)`;
/** Buffer hatching. */
export const bufferBg = `repeating-linear-gradient(90deg, rgba(255,180,84,.18) 0 3px, transparent 3px 8px)`;

export const fontCss = `
@import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,300..800&family=Spline+Sans+Mono:wght@300;400;500;600&display=swap');
.zb * { box-sizing: border-box; margin: 0; }
.zb { font-family: 'Bricolage Grotesque', sans-serif; }
.zb .mono { font-family: 'Spline Sans Mono', monospace; }
.zb ::-webkit-scrollbar { width: 0; height: 0; }
.zb input, .zb select, .zb button { font-family: inherit; }
@keyframes zbPulse { 0%,100%{opacity:1} 50%{opacity:.45} }
@keyframes zbRing { 0%{transform:scale(1);opacity:.5} 100%{transform:scale(1.9);opacity:0} }
@media (prefers-reduced-motion: reduce) { .zb * { animation: none !important; } }
`;
